import axiosInstance from '../config/axios.js';

const API_BASE = '/routes';

const routeService = {
  getAll: async (page = 1, perPage = 10, params = {}) => {
    const response = await axiosInstance.get(API_BASE, {
      params: { page, per_page: perPage, ...params },
    });
    return response.data;
  },

  getById: async (routeId) => {
    const response = await axiosInstance.get(`${API_BASE}/${routeId}`);
    return response.data;
  },

  create: async (routeData) => {
    const response = await axiosInstance.post(API_BASE, routeData);
    return response.data;
  },

  update: async (routeId, routeData) => {
    const response = await axiosInstance.put(`${API_BASE}/${routeId}`, routeData);
    return response.data;
  },

  delete: async (routeId) => {
    const response = await axiosInstance.delete(`${API_BASE}/${routeId}`);
    return response.data;
  },

  downloadDispatchTemplate: () =>
    axiosInstance.get(`${API_BASE}/dispatch-template`, { responseType: 'blob' }),

  previewDispatch: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return axiosInstance.post(`${API_BASE}/dispatch-preview`, formData, {
      headers: { 'Content-Type': undefined },
    });
  },

  confirmDispatch: (rows) =>
    axiosInstance.post(`${API_BASE}/dispatch-confirm`, { rows }),

  match: async (fromLocationIds = [], toLocationIds = []) => {
    const params = new URLSearchParams();
    (fromLocationIds || []).forEach((id) => params.append('from_location_ids', id));
    (toLocationIds || []).forEach((id) => params.append('to_location_ids', id));
    const response = await axiosInstance.get(`${API_BASE}/match?${params.toString()}`);
    return response.data;
  },
};

export default routeService;
